(function (window, document) {
  'use strict';

  function SearchPopup(options) {
    this.triggerSelector = options.triggerSelector;
    this.popupSelector = options.popupSelector;
    this.dialogSelector = options.dialogSelector;
    this.closeSelector = options.closeSelector;
    this.bodyClass = options.bodyClass;

    this.trigger = document.querySelector(this.triggerSelector);
    this.popup = document.querySelector(this.popupSelector);
    this.dialog = this.popup ? this.popup.querySelector(this.dialogSelector) : null;
    this.closeButtons = this.popup ? this.popup.querySelectorAll(this.closeSelector) : [];
    this.isOpen = false;
    this.lastActiveElement = null;

    this.handleTriggerClick = this.handleTriggerClick.bind(this);
    this.handleDocumentKeydown = this.handleDocumentKeydown.bind(this);
    this.handleCloseClick = this.handleCloseClick.bind(this);
  }

  SearchPopup.prototype.init = function () {
    var index;

    if (!this.trigger || !this.popup || !this.dialog) {
      return;
    }

    this.trigger.setAttribute('aria-controls', this.popup.id);
    this.trigger.setAttribute('aria-expanded', 'false');

    this.trigger.addEventListener('click', this.handleTriggerClick);
    document.addEventListener('keydown', this.handleDocumentKeydown);

    for (index = 0; index < this.closeButtons.length; index += 1) {
      this.closeButtons[index].addEventListener('click', this.handleCloseClick);
    }
  };

  SearchPopup.prototype.handleTriggerClick = function (event) {
    event.preventDefault();

    if (this.isOpen) {
      this.close();
      return;
    }

    this.open();
  };

  SearchPopup.prototype.handleCloseClick = function (event) {
    event.preventDefault();
    this.close();
  };

  SearchPopup.prototype.handleDocumentKeydown = function (event) {
    if (!this.isOpen) {
      return;
    }

    if (event.key === 'Escape') {
      event.preventDefault();
      this.close();
    }
  };

  SearchPopup.prototype.open = function () {
    var focusTarget;

    if (this.isOpen) {
      return;
    }

    this.isOpen = true;
    this.lastActiveElement = document.activeElement;
    this.popup.hidden = false;

    this.popup.setAttribute('aria-hidden', 'false');
    this.trigger.setAttribute('aria-expanded', 'true');
    document.body.classList.add(this.bodyClass);

    focusTarget = this.popup.querySelector('.search-field');

    if (focusTarget && typeof focusTarget.focus === 'function') {
      focusTarget.focus();
    }
  };

  SearchPopup.prototype.close = function () {
    if (!this.isOpen) {
      return;
    }

    this.isOpen = false;
    this.popup.hidden = true;
    this.popup.setAttribute('aria-hidden', 'true');
    this.trigger.setAttribute('aria-expanded', 'false');
    document.body.classList.remove(this.bodyClass);

    if (this.lastActiveElement && typeof this.lastActiveElement.focus === 'function') {
      this.lastActiveElement.focus();
    }
  };

  function bootSearchPopup() {
    var popup = new SearchPopup({
      triggerSelector: '.main__navigation__icon-button.lupe',
      popupSelector: '#site-search-popup',
      dialogSelector: '.search-popup__dialog',
      closeSelector: '[data-search-popup-close]',
      bodyClass: 'search-popup-open',
    });

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        popup.init();
      });
      return;
    }

    popup.init();
  }

  window.AderbalSearchPopup = {
    boot: bootSearchPopup,
  };

  bootSearchPopup();
})(window, document);
